import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from "vue-sweetalert2";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapActions } from "vuex";
import 'sweetalert2/dist/sweetalert2.min.css'
import VueLoading from "vuejs-loading-plugin";
import '@/assets/css/responsive-design.css'

Vue.use(Vuelidate);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDTvuisfH7eyVRBBYrZYTdaGhlOVb4LP9k",
    libraries: "places", // This is required if you use the Autocomplete plugin
    region: "AR",
    languaje: "es",
  },
  installComponents: true,
});

Vue.config.productionTip = false

Vue.prototype.$appVersion = "1.11.0";

Vue.use(VueSweetalert2);

Vue.use(VueLoading, {
  classes: ["page-loader"],
  text: "",
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
    created() {
    this.setAuth();
  },
  methods: {
    ...mapActions(["setAuth"]),
  },
}).$mount('#app')
